import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=4d960835&scoped=true"
import script from "./QuickReply.vue?vue&type=script&lang=js"
export * from "./QuickReply.vue?vue&type=script&lang=js"
import style0 from "./QuickReply.vue?vue&type=style&index=0&id=4d960835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d960835",
  null
  
)

export default component.exports